import type { RoleConfig } from '../types.js';

export const witch: RoleConfig = {
  id: 'witch',
  faction: 'solo',
  title: { ru: 'Ведьма', uk: 'Відьма' },
  latin: 'WITCH',
  number: '29',
  accent: '#7affc4',
  ability: {
    ru: 'Ночью берёт игрока под контроль и направляет его действие на выбранную ею жертву. Побеждает, оставшись последней.',
    uk: 'Уночі бере гравця під контроль і спрямовує його дію на обрану нею жертву. Перемагає, лишившись останньою.',
  },
  abilities: [
    {
      key: 'control',
      phase: 'night',
      cadence: 'every-night',
      shape: 'two-target', // targetId = the puppet, targetId2 = whom they act on
      canSelfTarget: false,
    },
  ],
  // Last-standing: with 'control' she can aim other killers, so the win is now
  // actually reachable by her own agency (and the stalemate guard backs it up).
  victory: { type: 'solo-last-standing' },
};
